export function getTotalIncome(totals) {
  if (!totals) return 0
  return parseFloat(totals.income) || 0
}

function summaryVisitCount(dataDashboard) {
  const count = parseInt(dataDashboard?.average?.summary?.total?.count, 10)
  return Number.isFinite(count) && count > 0 ? count : 0
}

export function recalculateIncomeAverages(dataDashboard, start, end) {
  if (!dataDashboard || !start || !end) return

  const startD = new Date(start)
  const endD = new Date(end)
  const msPerDay = 24 * 60 * 60 * 1000
  const diffDays = Math.max(1, Math.floor((endD - startD) / msPerDay) + 1)

  const totalIncome = getTotalIncome(dataDashboard.totals)
  const totalExpenses = parseFloat(dataDashboard.totals?.expenses) || 0
  const totalRefunds = parseFloat(dataDashboard.total_refunds) || 0
  const netIncome = totalIncome - totalExpenses - totalRefunds
  const visitCount = summaryVisitCount(dataDashboard)

  dataDashboard.average = dataDashboard.average || {}
  dataDashboard.average.income_days = Math.round(totalIncome / diffDays)
  dataDashboard.average.expenses_days = Math.round(totalExpenses / diffDays)
  dataDashboard.average.net_income_days = Math.round(netIncome / diffDays)

  if (visitCount > 0) {
    dataDashboard.average.income_day = totalIncome / visitCount
    dataDashboard.average.net_income_day = netIncome / visitCount
  } else if (dataDashboard.average.income_day == null) {
    dataDashboard.average.income_day = 0
    dataDashboard.average.net_income_day = 0
  }
}
